import { Outlet, Route, Routes } from 'react-router-dom';
import { AuthContextProvider } from './context/AuthContext';
import { MainAppProvider } from './context/MainContext';
import ProtectedRoute from './globals/ProtectedRoute';
import './App.css';
import './firebase.js';
import Signup from './pages/Signup';
import Signin from './pages/Signin';
import Home from './pages/Home';
import DetailSurat from './pages/DetailSurat';
import TafsirAyat from './pages/TafsirAyat';
import Riwayat from './pages/Riwayat';
import Contact from './pages/Contact';

function App() {
  return (
    <AuthContextProvider>
      <MainAppProvider>
        <Routes>
          <Route path='/' element={<Signin />} />
          <Route path='/daftar' element={<Signup />} />
          <Route element={<ProtectedRoute />}>
            <Route path='/beranda' element={<Home />} />
            <Route element={<Outlet />}>
              <Route
                path='/detailSurat/:namaSurat/:id/:ayatSaved'
                element={<DetailSurat />}
              />
              <Route
                path='/tafsirAyat/:nomorSurat/:id'
                element={<TafsirAyat />}
              />
            </Route>
            <Route path='/hafalan' element={<Riwayat />} />
            <Route path='/kontak' element={<Contact />} />
          </Route>
        </Routes>
      </MainAppProvider>
    </AuthContextProvider>
  );
}

export default App;
